import Vue from 'vue'
import ElementUI from 'element-ui';// 添加
import 'element-ui/lib/theme-chalk/index.css'; // 添加
import App from './App.vue'
import router from './router'
// import lazyload from './utils/lazyload';//图片懒加载
import VueLazyload from 'vue-lazyload';

Vue.config.productionTip = false // 添加 取消生产提示
Vue.use(ElementUI);// 添加
Vue.use(VueLazyload, {
    preLoad: 1.3, // 提前加载的倍数
    error: './assets/img7.jpeg', // 错误图片
    loading: './assets/img7.jpeg', // 加载中的占位图
  });

// Vue.directive('lazy', lazyload);

new Vue({
 router,
 render: h => h(App)
}).$mount('#app')
